import React, { useEffect, useMemo, useState, useCallback } from "react"
import { isEmpty } from "lodash"
import ReactECharts from "echarts-for-react"
import * as echarts from "echarts"
import birminghamJson from "./Birmingham.json" // Your GeoJSON file
import { useSelector, useDispatch } from "react-redux"

const BirminghamMap = () => {
  const { mapdistribution } = useSelector(state => state.Dashboard)
  const [londonGeoJSON, setLondonGeoJSON] = useState(null)
  const [clickedBorough, setClickedBorough] = useState(null)
  const [boroughData, setBoroughData] = useState(null)

  useEffect(() => {
    if (!isEmpty(mapdistribution)) {
      const boroughData = mapdistribution.reduce((acc, item) => {
        acc[item.BoroughName] = {
          datacount: item.DataCount,
          attendees: item.Attendees,
          simcards: item.Simcards,
        }
        return acc
      }, {})

      setBoroughData(boroughData)
    }
  }, [mapdistribution])

  // Register London borough map
  useEffect(() => {
    if (!echarts.getMap("birminghamBoroughs2018")) {
      echarts.registerMap("birminghamBoroughs2018", birminghamJson)
    }
    setLondonGeoJSON(birminghamJson)
  }, [])

  const onChartClick = useCallback(params => {
    setClickedBorough(params.name)
  }, [])

  // Chart options
  const option = useMemo(() => {
    if (!londonGeoJSON) return {}

    return {
      backgroundColor: "#fff",
      title: {
        text: "Total Health Days by Ward",
        left: "center",
        top: 20,
        textStyle: { fontSize: 24, fontWeight: "bold" },
      },
      tooltip: {
        trigger: "item",
        formatter: params => {
          //console.log(params)
          const value = boroughData[params.name] ?? "N/A"
          return `
          Total Health Days: ${value.datacount}<br/>
          Total Attendees: ${value.attendees}<br/>
          Total SIM Cards: ${value.simcards}
          `
        },
      },
      visualMap: {
        min: 0,
        max: 5,
        left: "right",
        bottom: 20,
        inRange: {
          color: [
            "#abd9e9",
            "#e0f3f8",
            "#ffffbf",
            "#fee090",
            "#fdae61",
            "#f46d43",
            "#d73027",
          ],
        },
        text: ["High", "Low"],
        calculable: true,
      },
      series: [
        {
          type: "map",
          map: "birminghamBoroughs2018",
          roam: false,
          label: { show: false },
          emphasis: {
            label: { show: true },
            itemStyle: { areaColor: "#ffc107" },
          },
          data: (londonGeoJSON?.features || []).map(f => {
            const boroughName = f?.properties?.name || "Unknown"
            const value =
              (boroughData && boroughData[boroughName]?.datacount) || 0
            return {
              name: boroughName,
              value: value,
            }
          }),
        },
      ],
    }
  }, [londonGeoJSON, boroughData])

  if (!londonGeoJSON) return <div>Loading London boroughs map...</div>

  return (
    <>
      <ReactECharts
        option={option}
        style={{ height: 600, width: "100%" }}
        onEvents={{ click: onChartClick }}
      />
      {clickedBorough && (
        <div
          style={{
            marginTop: 20,
            padding: 10,
            backgroundColor: "#f0f0f0",
            borderRadius: 4,
          }}
        >
          <h3>{clickedBorough}</h3>
          <p>Total Health Days: {boroughData[clickedBorough].datacount}</p>
          <p>Total Attendees: {boroughData[clickedBorough].attendees}</p>
          <p>Total SIM Cards: {boroughData[clickedBorough].simcards}</p>
        </div>
      )}
    </>
  )
}

export default BirminghamMap
